<div class="modal modal-container" tabindex="-1" role="dialog" #modal>
    <div class="modal-dialog backdrop" role="document">
        <div class="modal-content">
            <ng-content></ng-content>
        </div>
    </div>
</div>